module.exports = __webpack_public_path__ + "img/logo.bc61e5c3.png";